import { removeSlider } from './utilities.js';
import { stickyMainVariables } from './variables.js';


const slickSliderJS = () => {

	// Standard slider variables
	const { prevArrowHtml, nextArrowHtml, arrowsContainer, dotsContainer, delayBetweenSlides, animationSpeed } = stickyMainVariables();

	/* 
		More options available here: node_modules\slick-carousel\slick\slick.js
		Options can be overwitten by placing the options directly onto the slider HTML by adding data-slick ie.
		<div class="l-slick__area l-slick__area--slider" data-slider="standard" 
		data-slick='{ 
			"slidesToShow": 1,
			"responsive": [ 
				{
					"breakpoint": 767,
					"settings": {
						"slidesToShow": 1
					}
				}
			]
		}'>
	*/

	//====================================
	// Standard slider
	//====================================
	$("[data-slider='standard']").each(function () {
	    var slider = $(this);
		removeSlider(slider);
	 
	    slider.slick({
			prevArrow: prevArrowHtml,  
			nextArrow: nextArrowHtml, 
	        appendArrows: slider.parent().find(arrowsContainer),
	        appendDots: slider.parent().find(dotsContainer), 
			autoplaySpeed: delayBetweenSlides,
			speed: animationSpeed,
			dots: true,
			slidesToShow: 4,
			centerMode: true,  
			centerPadding: '0',
			responsive: [ 
				{
					breakpoint: 1200, 
					settings: {
						slidesToShow: 3, 
					}
				},
				{
					breakpoint: 992, 
					settings: {
						slidesToShow: 2, 
					}
				},
				{
					breakpoint: 767, 
					settings: {
						slidesToShow: 1, 
						variableWidth: true,
					}
				}
			]
	    });
	});

	//====================================
	// Standard slider
	//====================================
	$("[data-slider='basic']").each(function () {
		var slider = $(this);
		removeSlider(slider);

		slider.slick({
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			appendArrows: slider.parent().find(arrowsContainer),
			appendDots: slider.parent().find(dotsContainer),
			autoplaySpeed: delayBetweenSlides,
			speed: animationSpeed,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '0', 
		});

		const slides = document.querySelectorAll('[data-slickSlide]');

		if (slides.length > 0) {
			slides.forEach(slide => {
				slide.style.visibility = 'visible';
				slide.style.position = 'relative';
			})
		}

	});
}

// Self-invoke the function
slickSliderJS();

// Export the function for potential use in other files
export { slickSliderJS };















	
